import '../styles/index.css'
import { useArtworksContext } from '../hooks/useArtworksContext'
import { useAuthContext } from '../hooks/useAuthContext'

const ArtworkSubSectionDetails = ({ artwork }) => {
  const { dispatch } = useArtworksContext()
  const { user } = useAuthContext()

  return (
    <div className="flex flex-col justify-start px-6 text-center align-top rounded-lg">
      <div
        className="flex justify-center w-[100%] h-full mx-auto text-left rounded-lg artwork-details items-center"
      >
        <img src={artwork.imageBase64} alt="artwork"  className='max-w-full max-h-[300px] object-cover rounded-lg  bg-zinc-800 shadow-lg shadow-slate-950 hover:shadow-slate-700'/>
      </div>
    </div>
    
  )
}
export default ArtworkSubSectionDetails
